import styled, { css } from 'styled-components';

const FlexContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    // align-items: space-around;
    // justify-content: space-around;
    // gap: ${theme.margins.large};
    // margin: ${theme.margins.normal};
    margin: auto;
    width: 80%;
    height: 80%;
    z-index: ${theme.zIndexes.normal};
  `
);

export { FlexContainer };
